import { z } from 'zod';
import { ConversationParticipant } from '../client';
import { makeEvent } from './EventBase';

export const ConversationParticipantRemoved = makeEvent(
    'Conversation\\ConversationParticipantRemoved',
    z.object({
        data: ConversationParticipant,
    }),
);

export type ConversationParticipantRemoved = (typeof ConversationParticipantRemoved)['schema']['_output'];
